import React, { Component } from 'react';
import $ from 'jquery';
import DataTablesCreate from "./DataTablesCreate";

let headers = [
    {title: 'Código'},
    {title: 'Nombre'},
    {title: 'Sucursal'},
    {title: 'Departamento'}
];

class UsersModal extends Component {
    componentDidMount() {
        this.closeAction();
    }

    closeUsers = async () => {
        $('#usersModal').modal('hide');
    }

    closeAction = () => {
        const { cleanData } = this.props;
        $('#usersModal').on('hidden.bs.modal', function () {
            //console.log("cerrar personRequestModal");
            cleanData();
        });
    };


    render() {
        const {data, selectUser} = this.props;

        if(data.length === 0){
            return <div className="modal fade bd-example-modal-lg bgtransparent"  role="dialog"  id="usersModal"></div>;
        }

        return (
            <div>
                <div className="modal fade bd-example-modal-lg modal-open scroll"  role="dialog"  id="usersModal" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-open" role="document" >
                        <div className="modal-content">

                            <div className="modal-header text-white" style={{backgroundColor:'#343a40',borderRadius:'0'}}>
                                <h4 className="modal-title" id="modal-basic-title ">Usuarios</h4>
                                <button type="button" className="close" onClick={this.closeUsers} aria-label="Close">
                                    <span className="text-white" aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body" >
                                <div className="contanier">
                                    <div className="row justify-content-around">
                                        <div className="col-sm-6 col-md-8 col-lg-10 col-xl-12">
                                            <div>
                                                <table className="table" style={{marginBottom: 0}}>
                                                    <tbody>
                                                    <DataTablesCreate data={data} headers={headers} view={"usersModal"} action={selectUser}/>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn botonCerrar text-white" onClick={this.closeUsers}>Cerrar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default UsersModal;